<template>
  <div class="card__info">
    <div class="info__line" v-for="tag in tags">
      <i class="demo-icon icon-tick"></i><span class="">{{ tag }}</span>
    </div>
  </div>
</template>

<script>

export default {
  name: 'ElementInfo',
  components: {},
  props: {
    tags: Array,
  },
  methods: {},
};
</script>
